import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { formatNumber } from "digiwash-core";
import { Platform } from "react-native";

function parseMiliseconds(ms = 0) {
  let seconds: number | string = Math.floor((ms / 1000) % 60);
  let minutes: number | string = Math.floor((ms / (1000 * 60)) % 60);
  let hours: number | string = Math.floor(ms / (1000 * 60 * 60));

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return [hours, minutes, seconds];
}

let timeout_id;

export default function useCounter(
  input: string,
  start: boolean
): { text?: string } {
  let [desiredDate, setDesiredDate] = useState(input);
  let [timer, setTimer] = useState();

  let finalDate = dayjs(desiredDate).toDate();
  let finalDateInMs = finalDate.getTime();

  let currentTime = Date.now();
  let diff = dayjs(finalDateInMs).diff(dayjs(currentTime), "milliseconds");
  // each seconds we are updating `diff` and showing the result to user
  useEffect(() => {
    timeout_id = setTimeout(() => {
      if (diff >= 0 && hours < 24) {
        setTimer(diff);
      }
    }, 1000);

    return () => {
      clearTimeout(timeout_id);
    };
  }, [diff]);
  // in case of updating (component has been mounted already), we restart the timer and set the new date
  useEffect(() => {
    setTimer(undefined);
    setDesiredDate(input);
  }, [input]);
  // restart the states when `start` is false
  useEffect(() => {
    if (!start) {
      setTimer(undefined);
      setDesiredDate(undefined);
      clearTimeout(timeout_id);
    }
  }, [start]);

  let [hours, minutes, seconds] = parseMiliseconds(timer);

  let text;
  if (diff > 0) {
    // if (Platform.OS === "android") {
    text = `${formatNumber(dayjs(desiredDate).fromNow(true))} دیگر`;
    // }
    // else {
    //   if (hours <= 0 && minutes <= 0 && seconds <= 0) {
    //     text = undefined;
    //   } else if (hours < 24) {
    //     text =
    //       formatNumber(hours) +
    //       ":" +
    //       formatNumber(minutes) +
    //       ":" +
    //       formatNumber(seconds);
    //   } else {
    //     text = `${formatNumber(dayjs(desiredDate).fromNow(true))} دیگر`;
    //   }
    // }
  } else {
    text = "";
  }
  return { text };
}
